module.exports = __webpack_public_path__ + "media/images/checkout/challenger/calling_you_headset-2d53d5858f1a48e16c856d4e5db6cc3b.svg";